// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3olvR","col":"styles_col__1PcF8","fulfillmentStatus":"styles_fulfillmentStatus__3pMSm","emailCol":"styles_emailCol__3MvR7"};